// ighe3 API
export const API_URL = `https://api.ighe3.com/v1`;
export const API_URL2 = `https://api.ighe3.com/v5`;
export const API_MEDIA_URL = `${API_URL}/media/download`;
export const DEFAULT_PER_PAGE = 50;
export const bookImageUpload =
    "https://api.ighe3.com/v5/panel/book/image/upload";
export const bookFileUpload =
    "https://api.ighe3.com/v5/panel/book/file/upload";
